<template>
  <div class="news_container">
    <div class="news-mask">
      <div class="news-body">
        <div class="news_title font-title"></div>
        <div class="news-number-box flex" ref="newsContainer">
          <div class="news-item">
            <div class="item-title">覆盖城市</div>
            <div class="item-text">
              <dv-digital-flop ref="digital1Ref" :config="conf1" style="width: 100%; height: 50px" />
            </div>
          </div>
          <div class="news-item">
            <div class="item-title">运营场站</div>
            <div class="item-text">
              <dv-digital-flop ref="digital2Ref" :config="conf2" style="width: 100%; height: 50px" />
            </div>
          </div>
          <div class="news-item">
            <div class="item-title">设备数量</div>
            <div class="item-text">
              <dv-digital-flop ref="digital3Ref" :config="conf3" style="width: 100%; height: 50px" />
            </div>
          </div>
          <div class="news-item">
            <div class="item-title">合作伙伴</div>
            <div class="item-text">
              <dv-digital-flop ref="digital4Ref" :config="conf4" style="width: 100%; height: 50px" />
            </div>
          </div>
        </div>
        <div class="news-box flex align-center justify-between">
          <div class="news-right flex wrap">
            <div class="news-item pointer" @click="handleNav('/AIoT')">
              <div class="item-title">AIoT</div>
            </div>
            <div class="news-item pointer" @click="handleNav('/resolve')">
              <div class="item-title">解决方案</div>
            </div>
            <div class="news-item pointer" @click="handleNav('/shop')">
              <div class="item-title">产品中心</div>
            </div>
            <div class="news-item pointer" @click="handleNav('/service')">
              <div class="item-title">运维服务</div>
            </div>
            <div class="news-item pointer" @click="handleNav('/application')">
              <div class="item-title">案例展示</div>
            </div>
            <div class="news-item pointer" @click="handleNav('/about')">
              <div class="item-title">最新动态</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      conf1: {
        number: [0], // 默认数据
        textAlign: "center", //位置
        content: "{nt} +", //数字格式化
        style: {
          fontSize: 26, //文字大小
          fill: "#000", //文字颜色
        },
        formatter: this.formatter, // 自定义格式化函数
      },
      conf2: {
        number: [0], // 默认数据
        textAlign: "center", //位置
        content: "{nt} +", //数字格式化
        style: {
          fontSize: 26, //文字大小
          fill: "#000", //文字颜色
        },
        formatter: this.formatter, // 自定义格式化函数
      },
      conf3: {
        number: [0], // 默认数据
        textAlign: "center", //位置
        content: "{nt} +", //数字格式化
        style: {
          fontSize: 26, //文字大小
          fill: "#000", //文字颜色
        },
        formatter: this.formatter, // 自定义格式化函数
      },
      conf4: {
        number: [0], // 默认数据
        textAlign: "center", //位置
        content: "{nt} +", //数字格式化
        style: {
          fontSize: 26, //文字大小
          fill: "#000", //文字颜色
        },
        formatter: this.formatter, // 自定义格式化函数
      },
      hasTriggered: false, // 确保只触发一次
    };
  },
  methods: {
    // 自定义数字格式化函数
    formatter(number) {
      const numbers = number.toString().split("").reverse();
      const segs = [];
      while (numbers.length) segs.push(numbers.splice(0, 3).join(""));
      return segs.join(",").split("").reverse().join("");
    },
    // 处理滚动事件
    handleScroll() {
      const el = this.$refs.newsContainer;
      if (!el || this.hasTriggered) return;

      const rect = el.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;

      if (inView) {
        this.triggerAnimation();
        this.hasTriggered = true;
      }
    },
    // 触发动画
    triggerAnimation() {
      setTimeout(() => {
        this.conf1.number = [300];
        this.$refs.digital1Ref.update();
        this.conf2.number = [12000];
        this.$refs.digital2Ref.update();
        this.conf3.number = [179700];
        this.$refs.digital3Ref.update();
        this.conf4.number = [100];
        this.$refs.digital4Ref.update();
      }, 300);
    },
    // 跳转
    handleNav(url) {
      if (this.$router.currentRoute.path !== url) {
        this.$router.push(url);
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.min.css";

.news_container {
  width: 100vw;
  background: url("~@/assets/images/news/bg.jpeg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;

  .news-mask {
    width: 100%;
    padding-bottom: 280px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(8px) saturate(180%);
    -webkit-backdrop-filter: blur(8px) saturate(180%);

    .news-body {
      max-width: 1600px;
      height: 500px;
      margin: 0 auto;
      margin-bottom: 110px;
      z-index: 100;

      .news_title {
        padding-top: 70px;
        width: 100%;
        padding-bottom: 20px;
        text-align: center;
        color: #333 !important;
      }

      .news-number-box {
        width: calc(100% - 20px);
        margin-left: 10px;
        background-color: rgba(255, 255, 255, 0.7);
        box-sizing: border-box;

        .news-item {
          width: calc(25% - 20px);
          height: 100%;
          padding: 0 42.5px 30px 41px;
          box-sizing: border-box;
          transition: all 0.5s ease;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          margin: 10px;

          .item-title {
            font-size: 28px;
            color: #333;
            font-weight: 600;
            padding-top: 20px;
          }

          .item-text {
            width: 100%;
            font-size: 18px;
            color: #333;
            font-weight: 400;
            padding-top: 10px;
            text-align: center;
          }
        }
      }

      .news-box {
        margin-top: 44px;
        width: 100%;
        height: 100%;

        .news-right {
          width: 100%;
          height: 100%;

          .news-item {
            width: calc(33.3% - 20px);
            height: 50%;
            padding: 0 42.5px 30px 41px;
            box-sizing: border-box;
            transition: all 0.5s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(255, 255, 255, 0.7);
            margin: 10px;

            .item-title {
              font-size: 28px;
              color: #333;
              font-weight: 600;
              padding-top: 20px;
            }
          }

          .news-item:hover {
            box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.13);
          }
        }
      }
    }
  }
}
</style>
